import { useCallback, useContext, useEffect, useState } from "react";
import { markdownToHtml } from "../../../shared/helpers/utils";
import { IRichTextProps } from "./Richtext.interface";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import { ComponentTypes } from "../../../shared/interfaces/modules.interface";
import { useIntersectionObserver } from "../../../shared/hooks/useIntersectionObserver";

function RichText(props: IRichTextProps) {
    const { unitId, id } = props;
    const { progress, setProgress } = useContext(ModuleContext);
    const { lang } = useContext(TranslationContext);
    const [isCompleted, setIsCompleted] = useState<boolean>(false);

    const checkProgress = useCallback(
        (entry: any) => {
            const isItemId = props.id === progress?.itemId && props.type === progress?.itemType;

            if (entry.isIntersecting && !isItemId && !isCompleted) {
                handleProgress();
            }
        },
        [progress, props, isCompleted]
    );

    const handleProgress = useCallback(() => {
        if (lang && unitId) {
            setProgress({
                unitId: unitId,
                itemId: id,
                progress: 100,
                itemType: ComponentTypes.RICH_TEXT,
                itemLocale: lang
            });
            setIsCompleted(true);
        }
    }, [lang, unitId]);

    const { ref } = useIntersectionObserver(checkProgress);

    return (
        <section className="unit_item container-fluid gx-2">
            <div className="row gx-0">
                <div className="col-12">
                    <div
                        className="text-bd2-md rich_text"
                        dangerouslySetInnerHTML={{ __html: markdownToHtml(props.content) }}
                    />
                    <div ref={ref}></div>
                </div>
            </div>
        </section>
    );
}

export default RichText;
